// What this device offers, decided from two switches: the operator's (the edge's /health
// `features`, lib/edgeStatus.ts) and the user's own backends (lib/backends.ts). Barcode and e-label
// QR scanning are not features in this sense: they work for everyone, on the device catalogue or
// druif. Only label-photo scanning is flagged, because it costs the operator AI usage.
import { useBackends } from "./backends";
import { useEdgeFeatures } from "./edgeStatus";

/**
 * Whether the label-photo scanner is offered: the edge's `labelScan` flag is on AND the edge is
 * enabled in About (the photo is read there, by Workers AI; druif is not involved). Off by default,
 * and off while the edge has not answered yet.
 */
export function useLabelScan(): boolean {
  const { labelScan } = useEdgeFeatures();
  return useBackends().edge.enabled && labelScan;
}
